import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ScreenDeviceModel } from '../models/screen_device_model';
import { TScreenDevice } from '../models/screen_device_model';

export type UpdateScreenDeviceCommand = (screenDevice: TScreenDevice) => ng.IPromise<IQuery[]>;

angular
  .module('ng-screen-query')
  .factory('updateScreenDeviceCommand', (defineCommandORM: IDefineCommand, ngScreenDeviceModel: ScreenDeviceModel) =>
    defineCommandORM('updateScreenDeviceCommand', (deferred, screenDevice: TScreenDevice) => {
      ngScreenDeviceModel.write({
        screen_device: screenDevice
      });

      return deferred.resolve();
    })
  );



// WEBPACK FOOTER //
// ./app/vendor/screen-query/src/commands/update_screen_device_command.ts